(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .directive('sodAppointmentSelectParticipant',sodAppointmentSelectParticipant);

    const template = `
        <div class="participants-wrapper">
            <div class="participants-selector-wrapper">
                <div>
                    <input type="text" placeholder="Participant Type (users, clients, candidates)" />
                </div>
                <div kendo-list-view="vm.sourceList" k-options="vm.sourcelistOptions">
                    <div k-template>
                        <div class="participant-person">
                            <div class="participant-image"></div>
                            <div class="participant-name" ng-bind="dataItem"></div>
                            <button type="button" class="button default small btn-add-participant" ng-click="vm.add(dataItem)">Add</button>
                        </div>
                    </div>
                </div>
                <div kendo-pager k-data-source="vm.sourcelistOptions.dataSource"></div>
            </div>
            <div class="selected-participants-wrapper">
                <div class="selected-participant-list">
                    <div class="selected-participant-header">Selected</div>
                    <ul>
                        <li ng-repeat="participant in vm.participants track by $index">
                            <div class="participant-image"></div>
                            <div ng-bind="participant" class="participant-name"></div><!--
                            --><div class="label default round">Interviewer</div>
                            <a ng-click="vm.remove(participant)" class="remove-participant"><i class="fa fa-times"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `;

    function sodAppointmentSelectParticipant() {
        return {
            restrict: 'E',
            controller: sodAppointmentSelectParticipantCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                getParticipants: '=?'
            },
            template: template
        };
    }

    function sodAppointmentSelectParticipantCtrl() {
        const vm = this;
        this.$onInit = function() {
            vm.getParticipants = getParticipants;
            vm.add = add;

            vm.participants = ['a', 'list', 'of', 'participants'];

            vm.sourcelistOptions = {
                dataSource: new kendo.data.DataSource({
                    data: [
                        'a', 'b', 'c', 'd'
                    ]
                })
            };
        }

        function add(dataItem) {
            vm.participants.push(dataItem);
        }

        function getParticipants() {
            return vm.participants;
        }
    }
})();